import React from 'react';
import { CardDesign } from '../../../../../../../components/CardDesign';
import PeriodSelection from './PeriodSelection';
import { ReactComponent as DatePeriodIcon } from '../../../../../../../resource/DatePeriodIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { selectShutdownsFilter } from '../../../model/selectors';
import { dateRangeShutdownsEnum } from '../../../../../shared/constants/dateRangeShutdownsEnum';
import { applyShutdownFilter } from '../../../model/actions';
import {
  SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER,
  SET_DATE_RANGE_SHUTDOWN_FILTER,
} from '../../../model/types';

const optionChoice = [
  {
    name: 'Дата создания',
    id: dateRangeShutdownsEnum.CREATE,
    value: dateRangeShutdownsEnum.CREATE,
    key: dateRangeShutdownsEnum.CREATE,
    content: 'Дата создания',
    search: 'Дата создания',
  },
  {
    name: 'Дата начала',
    id: dateRangeShutdownsEnum.START,
    value: dateRangeShutdownsEnum.START,
    key: dateRangeShutdownsEnum.START,
    content: 'Дата начала',
    search: 'Дата начала',
  },
  {
    name: 'Дата завершения плановая',
    id: dateRangeShutdownsEnum.COMPLETION_PLANNED,
    value: dateRangeShutdownsEnum.COMPLETION_PLANNED,
    key: dateRangeShutdownsEnum.COMPLETION_PLANNED,
    content: 'Дата завершения плановая',
    search: 'Дата завершения плановая',
  },
  {
    name: 'Дата завершения фактическая',
    id: dateRangeShutdownsEnum.COMPLETION_ACTUAL,
    value: dateRangeShutdownsEnum.COMPLETION_ACTUAL,
    key: dateRangeShutdownsEnum.COMPLETION_ACTUAL,
    content: 'Дата завершения фактическая',
    search: 'Дата завершения фактическая',
  },
];

const PeriodSelectionFilterCard = () => {
  const { dateRangeField, dateRange } = useSelector(selectShutdownsFilter);

  const dispatch = useDispatch();

  const makeChangeHandler = (actionType) => (value) => {
    dispatch(applyShutdownFilter(actionType)(value));
  };

  const rangeFieldConfig = {
    data: optionChoice,
    value: dateRangeField,
    onChange: makeChangeHandler(SET_DATE_RANGE_FIELD_SHUTDOWN_FILTER),
    placeholder: 'Выбор',
    isClear: false,
  };

  const dateReangeConfig = {
    value: dateRange,
    onChange: makeChangeHandler(SET_DATE_RANGE_SHUTDOWN_FILTER),
  };

  return (
    <CardDesign style={{ backgroundColor: 'white' }}>
      <CardDesign.Header
        heading="Период и выбор"
        icon={<DatePeriodIcon />}
      />

      <CardDesign.Body>
        <PeriodSelection
          rangeFieldConfig={rangeFieldConfig}
          dateReangeConfig={dateReangeConfig}
        />
      </CardDesign.Body>
    </CardDesign>
  );
};

export default PeriodSelectionFilterCard;
